import type { DirectorySport } from '../../types/directory';

/** The URL parameter a system admin's sport choice rides in, so a shared link opens on the same sport. */
export const SPORT_PARAM = 'sport';

const keyFor = (userId: string) => `rosterpilot.directorySport.v1.${userId}`;

/** `baseball` or `softball` (any case, trimmed), else null. */
export const parseDirectorySport = (value: string | null | undefined): DirectorySport | null => {
  const sport = value?.trim().toLowerCase();
  return sport === 'baseball' || sport === 'softball' ? sport : null;
};

/**
 * The sport a system admin last picked, remembered in this browser per user. A convenience only:
 * blocked or cleared storage just means the switch starts on the organization's sport.
 */
export const readStoredSport = (userId: string | null | undefined): DirectorySport | null => {
  if (!userId) return null;
  try {
    return parseDirectorySport(window.localStorage.getItem(keyFor(userId)));
  } catch {
    return null;
  }
};

export const writeStoredSport = (userId: string | null | undefined, sport: DirectorySport): void => {
  if (!userId) return;
  try {
    window.localStorage.setItem(keyFor(userId), sport);
  } catch {
    // Storage blocked or full: the choice still holds for this session.
  }
};
